import React from 'react'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { CountType } from 'enums'
import messageUtil from 'utils/messageUtil'

import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { getLabel } from 'utils/widgetTypeUtil'
import { SocialWebSentimentWidget as SocialWebSentimentWidgetType } from 'schemas/SocialWebSentimentWidgetSchema'
import { TopicNotSelectedGuard, WidgetLoadingGuard } from 'components/widget/share/guards'
import SentimentWidgetDataGuards from '../share/guards/SentimentWidgetDataGuards'
import Sentiment from '../share/Sentiment'
import RunSearchEffect from './RunSearchEffect'
import InsightModal from '../share/InsightModal'
import useSelectedInsights from '../share/InsightModal/hooks/useSelectedInsights'

interface SocialWebSentimentWidgetProps {
  widgetId: number
}

const SocialWebSentimentWidget = ({
  widgetId
}: SocialWebSentimentWidgetProps): React.ReactElement => {
  const widgetSetting = useDashboardWidgetSetting<SocialWebSentimentWidgetType>(widgetId)
  const {
    isModalOpen,
    selectedInsights,
    detailSetting,
    widgetSettingWithSelection,
    onClick,
    onClose
  } = useSelectedInsights(widgetSetting)

  return (
    <UnexpectedErrorBoundary>
      <TopicNotSelectedGuard widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <WidgetLoadingGuard widgetId={widgetId}>
            <SentimentWidgetDataGuards widgetId={widgetId}>
              <Sentiment
                widgetId={widgetId}
                seriesName={messageUtil.countType(CountType.MENTIONS)}
                onClick={onClick}
              />
            </SentimentWidgetDataGuards>
          </WidgetLoadingGuard>
        </RunSearchEffect>
      </TopicNotSelectedGuard>
      <InsightModal
        open={isModalOpen}
        onClose={onClose}
        title={widgetSetting?.name || getLabel(widgetSetting?.type)}
        countType={CountType.MENTIONS}
        selectedInsights={selectedInsights}
        detailSetting={detailSetting}
        widgetSettingWithSelection={widgetSettingWithSelection}
      />
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebSentimentWidget
